import {
  PAYMENT_TYPE_FIELD_CONFIG,
  PAYMENT_TYPES,
} from "../config/lipaBidhaaConfig";

const paybillAliasConstraints =
  PAYMENT_TYPE_FIELD_CONFIG[PAYMENT_TYPES.PAYBILL];
const tillNumberAliasConstraints =
  PAYMENT_TYPE_FIELD_CONFIG[PAYMENT_TYPES.TILL_NUMBER];
const paykitAliasConstraints = PAYMENT_TYPE_FIELD_CONFIG[PAYMENT_TYPES.B2B];

const validateAmount = (v) => {
  if (!v) return "Amount is required";
  if (Number(v) < 1) return "Amount must be at least KSh 1";
  if (Number(v) > 250000) return "Amount must not exceed KSh 250,000";
  return null;
};

export const paybillValidators = {
  alias: (v) => {
    const str = String(v ?? "").trim();
    if (!str) return "Paybill number is required";
    if (!/^\d+$/.test(str)) return "Paybill number must contain digits only";
    if (
      str.length < paybillAliasConstraints.aliasMinLength ||
      str.length > paybillAliasConstraints.aliasMaxLength
    )
      return `Paybill number must be ${paybillAliasConstraints.aliasMinLength}–${paybillAliasConstraints.aliasMaxLength} digits`;
    return null;
  },

  accountNumber: (v) => {
    const str = String(v ?? "").trim();
    if (!str) return "Account number is required";
    if (str.length > 13) return "Account number must be 13 characters or less";
    return null;
  },

  amount: validateAmount,
};

export const tillValidators = {
  alias: (v) => {
    const str = String(v ?? "").trim();
    if (!str) return "Till number is required";
    if (!/^\d+$/.test(str)) return "Till number must contain digits only";
    if (
      str.length < tillNumberAliasConstraints.aliasMinLength ||
      str.length > tillNumberAliasConstraints.aliasMaxLength
    )
      return `Till number must be ${tillNumberAliasConstraints.aliasMinLength}–${tillNumberAliasConstraints.aliasMaxLength} digits`;
    return null;
  },

  amount: validateAmount,
};

export const paykitValidators = {
  alias: (v) => {
    const str = String(v ?? "").trim();
    if (!str) return "Merchant ID is required";
    if (!/^[a-zA-Z0-9 ]+$/.test(str))
      return "Merchant ID must be alphanumeric only";
    if (str.length > paykitAliasConstraints.aliasMaxLength)
      return `Merchant ID must not exceed ${paykitAliasConstraints.aliasMaxLength} characters`;
    return null;
  },

  amount: validateAmount,
};
